import Cookies from 'js-cookie';

function AuthController($rootScope,$scope, $location, $http, CharitySvc, AffiliateSvc) {
  'ngInject';

  jQuery(document).ready(function ($) {
      if (Cookies.get('TLF_Auth_Token') !== undefined) {
          $http.get(TFL_Base_Url + 'auth?ApiKey=' + Cookies.get('TLF_Auth_Token'))
            .then(function (response) {
                var data = response.data;
                //Check if they have not confirmed email address.
                if (data.isEmailConfirmed == null || data.isEmailConfirmed == false) {
                    $rootScope.Email = data.Email;
                    $('#modal').show();
                    $('#complete').fadeIn(400);
                }


                if (Cookies.get('CharityID') != null)
                {
                  CharitySvc.member_set({ APIKey: Cookies.get('TLF_Auth_Token'), Id:  Cookies.get('CharityID')}, function (data) {
                    if (data.Id != null)
                    {
                      $rootScope.Charity_Enabled = true;
                      $rootScope.Charity = data;
                    }
                  });
                }
                else
                {
                  //Charity Stuff
                  if (data.CharityId != null )
                  {
                    CharitySvc.get({ Id: data.CharityId}, function (data) {
                      if (data.Id != null)
                      {
                        var date = new Date();
                        var minutes = 60000;
                        date.setTime(date.getTime() + (minutes * 60 * 1000));
                        Cookies.set('CharityID', data.Id, { expires: date });
                        $rootScope.Charity_Enabled = true;
                        $rootScope.Charity = data;
                      }
                    });
                  }
                }

                if (Cookies.get('AffiliateID') != null)
                {
                  AffiliateSvc.member_set({ APIKey: Cookies.get('TLF_Auth_Token'), Id:  Cookies.get('AffiliateID')}, function (data) {
                    if (data.Id != null)
                    {
                      $rootScope.Affiliate_Enabled = true;
                      $rootScope.Affiliate = data;
                    }
                  });
                }
                else
                {
                  //Affiliate Stuff
                  if (data.AffiliateId != null )
                  {
                    AffiliateSvc.get({ Id: data.AffiliateId}, function (data) {
                      if (data.Id != null)
                      {
                        var date = new Date();
                        var minutes = 60000;
                        date.setTime(date.getTime() + (minutes * 60 * 1000));
                        Cookies.set('AffiliateID', data.Id, { expires: date });
                        $rootScope.Affiliate_Enabled = true;
                        $rootScope.Affiliate = data;
                      }
                    });
                  }
                }

                //set URL to home
                $location.url($location.path('/home').replace());
                $location.path('/home').replace();
            }, function () {
                Cookies.remove('TLF_Auth_Token');
                Cookies.remove('Member_Id');
                Cookies.remove('Email');
                $location.url($location.path('/home').replace());
                $location.path('/home').replace();
            });
      }
      else {
          $location.url($location.path('/home').replace());
          $location.path('/home').replace();
      }
      
      Cookies.set('TLF_HasLoggedIn', true); // set as true for logic around reminder snackbar for returning visitors that are logged in
      
  		if ( Cookies.get('TLF_ItemsInCart') == 'true' ) {
  			setTimeout(function(){
  			  $('#cartReminder').fadeIn(500).delay(5000).fadeOut(500);
  		  }, 1000);
  		} // show cartReminder snackbar if they're a returning user with items in their cart

  });
};

export default {
  name: 'authController',
  fn: AuthController
}